import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {loadEtlAudit} from 'store/slices/etl-slice/api/thunks';
import {IEtlAuditTableData, IEtlSliceState} from 'store/slices/etl-slice/model/types';

import {ETL_SLICE} from './constants';

const initialState: IEtlSliceState = {
    etlAuditData: {},
    isLoading: false,
};

export const etlSlice = createSlice({
    initialState,
    name: ETL_SLICE,
    reducers: {
        setEtlAudit(state, {payload: data}: PayloadAction<IEtlAuditTableData>) {
            state.etlAuditData = data;
        },
        setIsLoading(state, {payload: data}: PayloadAction<boolean>) {
            state.isLoading = data;
        },
        resetEtlAudit(state) {
            state.etlAuditData = {};
            state.isLoading = false;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(loadEtlAudit.pending, state => {
                state.isLoading = true;
            });
        builder
            .addCase(loadEtlAudit.fulfilled, (state, action) => {
                state.isLoading = false;
                state.etlAuditData = action.payload;
            });
        builder
            .addCase(loadEtlAudit.rejected, state => {
                state.isLoading = false;
            });
    },
});

export const {reducer: etlSliceReducer} = etlSlice;
export const {resetEtlAudit} = etlSlice.actions;